var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVine10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2560 1440",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m118.57,1451.07c-132.14,-332.14 17.86,-667.86 131.43,-785c113.57,-117.14 334.64,-190 410.71,0c76.07,190 -151.07,270.71 -23.21,482.14c127.86,211.43 518.57,240.36 980.36,192.86c461.79,-47.5 625.71,-218.57 719.64,-392.86c93.93,-174.29 147.14,-357.86 148.21,-508.93c1.07,-151.07 -52.86,-318.57 -255.36,-362.5c-202.5,-43.93 -399.29,27.86 -535.71,221.43c-136.43,193.57 -77.86,388.57 -260,499.29c-182.14,110.71 -523.21,-44.64 -498.21,-314.29c25,-269.64 276.79,-223.21 363.57,-411.79c86.79,-188.57 -413.57,-261.43 -413.57,-261.43c0,0 -585.71,19.64 -586.43,20.36c-0.71,0.71 -547.5,-91.79 -546.43,264.29c1.07,356.07 -8.21,274.29 -7.14,630.36c1.07,356.07 11.43,456.43 12.5,455.36c1.07,-1.07 79.29,510 81.07,515.36c1.79,5.36 410.71,87.5 278.57,-244.64z",
    fill: "#000000",
    fillOpacity: 0,
    id: "vinePath",
    stroke: "#000000",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVine10);
export default __webpack_public_path__ + "static/media/vine10.2e674618ec78faf8e16a6654584e8b54.svg";
export { ForwardRef as ReactComponent };